import React from 'react';
import styled from 'styled-components';
import { Tag as AntdTag, Skeleton as AntdSkeleton } from 'antd';
import { formatCurrency } from 'utils';

const StyledTag = styled(AntdTag)<{ $hideMargin?: boolean }>`
  && {
    border: none;
    font-size: 14px;
    padding: 4px;
    ${({ $hideMargin }) => $hideMargin && `margin: 0`};
  }
`;

const StyledSkeleton = styled(AntdSkeleton.Button)`
  && {
    vertical-align: top;
    &,
    > * {
      height: 28px;
    }
  }
`;

export type PriceTagProps = {
  price?: number;
  loading?: boolean;
  success?: boolean;
  hideMargin?: boolean;
};

export const PriceTag: React.FC<PriceTagProps> = ({
  price,
  loading,
  success,
  hideMargin,
}) => {
  const getColor = () => {
    if (success) return 'green';
    return 'blue';
  };

  if (loading) return <StyledSkeleton active />;

  return (
    <StyledTag color={getColor()} $hideMargin={hideMargin}>
      {formatCurrency(price)}
    </StyledTag>
  );
};

export default styled(PriceTag)``;
